// src/main.js

// Core functionality imports
import { initiateEbayOAuth } from './oauth.js';
import { handleOAuthCallback } from './ebay_oauth_callback.js';
import { setupAuthentication } from '../auth.js';

// Utility imports
import { fetchCardData } from '../data/update_operations.js';
import config from '../../config';
import { setupUserToken, getUserToken } from '../auth_utils';
import '../navbar.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize authentication
  setupAuthentication(handleLoginSuccess, handleLoginFailure);

  // Handle OAuth callback if on the specific page
  if (window.location.pathname === '/ebay_oauth_callback.html') {
    handleOAuthCallback();
  }
});

// Handle successful login by verifying the user and checking eBay connection
async function handleLoginSuccess(user, token) {
  const headers = setupUserToken(token);
  await checkEbayConnection(headers);
  await checkRedditConnection(headers);

  // Attach event listeners after authentication
  setupEventListeners(headers);
}

// Handle login failure
function handleLoginFailure() {
  alert('Authentication failed. Please log in again.');
  window.location.href = '/login.html'; // Redirect to login page if needed
}

// Function to set up event listeners
function setupEventListeners(headers) {
  // eBay buttons
  const connectEbayButton = document.getElementById('connect-ebay-button');
  const disconnectEbayButton = document.getElementById(
    'disconnect-ebay-button'
  );

  // Reddit buttons
  const connectRedditButton = document.getElementById('connect-reddit-button');
  const disconnectRedditButton = document.getElementById(
    'disconnect-reddit-button'
  );

  // eBay event listeners
  if (connectEbayButton) {
    connectEbayButton.addEventListener('click', () => initiateEbayOAuth());
  }

  if (disconnectEbayButton) {
    disconnectEbayButton.addEventListener('click', () =>
      disconnectEbayAccount(headers)
    );
  }

  // Reddit event listeners
  if (connectRedditButton) {
    connectRedditButton.addEventListener('click', () => initiateRedditOAuth());
  }

  if (disconnectRedditButton) {
    disconnectRedditButton.addEventListener('click', () =>
      disconnectRedditAccount(headers)
    );
  }
}

async function initiateRedditOAuth() {
  try {
    // Make an authenticated request to your backend to get the Reddit auth URL
    window.location.href = `${config.detectionUrl}/reddit-login`;
  } catch (error) {
    console.error('Error initiating Reddit OAuth:', error);
    alert('An error occurred while initiating Reddit OAuth.');
  }
}

// Function to check eBay connection status
async function checkEbayConnection(headers) {
  try {
    const response = await fetchCardData(
      `${config.detectionUrl}/check-ebay-connection`,
      'GET',
      headers,
      null
    );

    const connectButton = document.getElementById('connect-ebay-button');
    const disconnectButton = document.getElementById('disconnect-ebay-button');

    if (response.body.connected) {
      // User is connected; update UI
      if (connectButton) connectButton.style.display = 'none';
      if (disconnectButton) disconnectButton.style.display = 'inline-block';
    } else {
      // User is not connected; ensure the connect button is visible
      if (connectButton) connectButton.style.display = 'inline-block';
      if (disconnectButton) disconnectButton.style.display = 'none';
    }
  } catch (error) {
    console.error('Error checking eBay connection:', error);
  }
}

// Function to check Reddit connection status
async function checkRedditConnection(headers) {
  try {
    const response = await fetchCardData(
      `${config.detectionUrl}/check-reddit-connection`,
      'GET',
      headers,
      null
    );

    const connectRedditButton = document.getElementById(
      'connect-reddit-button'
    );
    const disconnectRedditButton = document.getElementById(
      'disconnect-reddit-button'
    );

    if (response.body.connected) {
      // User is connected; update UI
      if (connectRedditButton) connectRedditButton.style.display = 'none';
      if (disconnectRedditButton)
        disconnectRedditButton.style.display = 'inline-block';
    } else {
      // User is not connected; ensure the connect button is visible
      if (connectRedditButton)
        connectRedditButton.style.display = 'inline-block';
      if (disconnectRedditButton) disconnectRedditButton.style.display = 'none';
    }
  } catch (error) {
    console.error('Error checking Reddit connection:', error);
  }
}

async function disconnectEbayAccount() {
  if (!confirm('Are you sure you want to disconnect your eBay account?')) {
    return;
  }

  try {
    const token = getUserToken();
    if (!token) {
      alert('User is not authenticated. Please log in again.');
      window.location.href = '/login.html';
      return;
    }
    const headers = setupUserToken(token);

    const response = await fetchCardData(
      `${config.detectionUrl}/disconnect-ebay`,
      'POST',
      headers,
      null
    );

    if (response.body.success) {
      alert('Your eBay account has been disconnected.');
      // Update the UI to reflect the disconnected state
      await checkEbayConnection(headers);
    } else {
      alert('Error disconnecting your eBay account: ' + data.error);
    }
  } catch (error) {
    console.error('Error disconnecting eBay account:', error);
    alert('An error occurred while disconnecting your eBay account.');
  }
}

// Function to disconnect Reddit account
async function disconnectRedditAccount(headers) {
  if (!confirm('Are you sure you want to disconnect your Reddit account?')) {
    return;
  }

  try {
    const response = await fetchCardData(
      `${config.detectionUrl}/disconnect-reddit`,
      'POST',
      headers,
      null
    );

    if (response.body.success) {
      alert('Your Reddit account has been disconnected.');
      // Update the UI to reflect the disconnected state
      await checkRedditConnection(headers);
    } else {
      alert('Error disconnecting your Reddit account: ' + response.body.error);
    }
  } catch (error) {
    console.error('Error disconnecting Reddit account:', error);
    alert('An error occurred while disconnecting your Reddit account.');
  }
}
